// language=GraphQL
export const GRAPHQL_QUERY_PRODUCT_SLMID = `
  query showCosmosDbProductsV3($filter: String!, $skip: Int!, $top: Int! ) {
    showCosmosDbProductsV3 (filter: $filter, skip: $skip, top: $top) {
      products {
        technicalName
        id
        commercial {
          editions {
            materialNumber
            name
            parentTechnicalName
            code
            id
          }
        }
        productName
      }
    }
  }
`;
// language=GraphQL
export const GRAPHQL_QUERY_PRODUCT_FULL = `
  query showCosmosDbProductsV3($filter: String!, $skip: Int!, $top: Int! ) {
    showCosmosDbProductsV3 (filter: $filter, skip: $skip, top: $top) {
      products {
        technicalName
        id
        productName
        sapComLayout
        semaphoreId
        url
        labels
        metaKeywords
        reviewId
        link {
          href
          rel
        }
        content {
          privacyUrl
          termsUrl
          description {
            small
            medium
            large
          }
          features {
            headline
            text
            type
            media {
              type
              title
              altText
              url
              format
            }
          }
          support {
            phone
            email
          }
          resources {
            type
            text
            value
            altText
            classification {
              id
              name
            }
          }
          media {
            type
            title
            altText
            url
            format
            textContent
          }
        }
        attributes {
          categories {
            type
            id
            val
            group
            parentProductCategory {
              type
              id
              val
              group
            }
          }
          useCases {
            code
            name
          }
          selfDeclarations {
            id
            type
            header
            val
          }
          solutionTypes {
            code
            name
          }
          technologies {
            code
            name
          }
          certifications {
            code
            name
            validUntil
            otherName
            media {
              type
              title
              altText
              url
              format
              textContent
            }
          }
          industries {
            code
            name
          }
        }
        commercial {
          editions {
            materialNumber
            internalId
            technicalName
            id
            name
            displayOrder
            userProfile
            validFrom
            validUntil
            parentTechnicalName
            code
            labels
            audience
            privacyUrl
            termsUrl
            mandatoryPrerequisites
            ctas {
              code
              name
            }
            editionFeatures {
              value
              name
            }
            features {
              name
              value
            }
            includes {
              amount
              unlimited
              metric {
                code
                name
              }
            }
            productMetrics {
              id
              name
              description
              elasticity
            }
            productCategories {
              type
              id
              val
              group
              parentProductCategory {
                type
                id
                val
                group
              }
            }
            productQuantity {
              minQuantity
              maxQuantity
              quantityIncrement
            }
            salesMetric {
              id
              name
              description
              elasticity
            }
            commitmentPeriod {
              max
              min
              unit {
                id
                name
              }
            }
            prerequisites {
              materialNumber
              materialName
              targetUrl
              orConnections {
                materialNumber
                materialName
                targetUrl
              }
              andConnections {
                materialNumber
                materialName
                targetUrl
                orConnections {
                  materialNumber
                  materialName
                  targetUrl
                }
                andConnections {
                  materialNumber
                  materialName
                  targetUrl
                  orConnections {
                    materialNumber
                    materialName
                    targetUrl
                  }
                  andConnections {
                    materialNumber
                    materialName
                    targetUrl
                    orConnections {
                      materialNumber
                      materialName
                      targetUrl
                    }
                    andConnections {
                      materialNumber
                      materialName
                      targetUrl
                      orConnections {
                        materialNumber
                        materialName
                        targetUrl
                      }
                      andConnections {
                        materialNumber
                        materialName
                        targetUrl
                      }
                    }
                  }
                }
              }
            }
            blocksOf {
              code
              amount
              metric {
                elasticity
                technicalName
                name
              }
            }
            prices {
              type
              currency
              revenueCloudMarketId
              group {
                id
                validFrom
              }
              blockRates {
                metricId
                metricName
                minimumBlocks
                blockSize
                pricePerBlock
                includedQuantity
              }
              tierRates {
                metricId
                metricName
                minimumBlocks
                blockSize
              }
              allUnitVolumeRates {
                metricId
                metricName
                minimumBlocks
                blockSize
              }
              setupFees {
                metricId
                metricName
                price
              }
              percentageFees {
                metricId
                metricName
                ratio
              }
              fixedRates {
                metricId
                metricName
                price
                billedInAdvance
              }
              periodicity {
                code
                name
              }
              markets {
                marketId
              }
            }
            additionalPropertiesList {
              propertyName
              propertyValue
            }
          }
          worksWith {
            textualPrerequisites {
              text
              type
            }
            technicalAssetPrerequisites {
              text
              type
            }
          }
        }
        ctas {
          code
          name
        }
        metadata {
          technicalAssetId
          createdAt
          lastModifiedDate
          type
        }
        publisher {
          name
          description
          url
          logo
          publisherType
        }
        additionalPropertiesList {
          propertyName
          propertyValue
        }
        commonProductFeatures {
          value
          name
        }
      }
    }
  }
`;
// language=GraphQL
export const GRAPHQL_QUERY_PRODUCT_BASIC = `
  query showCosmosDbProductsV3($filter: String!, $skip: Int!, $top: Int! ) {
    showCosmosDbProductsV3 (filter: $filter, skip: $skip, top: $top) {
      products {
        technicalName
        productName
        url
        ctas {
          code
          name
        }
        commercial {
          editions {
            materialNumber
            internalId
            validFrom
            validUntil
            code
            ctas {
              code
              name
            }
            labels
            audience
            privacyUrl
            termsUrl
            mandatoryPrerequisites
            additionalPropertiesList {
              propertyName
              propertyValue
            }
          }
        }
        publisher {
          name
          description
          url
          logo
          publisherType
        }
        metadata {
          technicalAssetId
          createdAt
          lastModifiedDate
        }
        labels

        additionalPropertiesList {
          propertyName
          propertyValue
        }
      }
    }
  }
`;

